import React from 'react';
import { LanguageProvider } from './lib/LanguageContext';
import { SalesLetterPage } from './components/SalesLetterPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <SalesLetterPage data-id="element-1" />
    </LanguageProvider>;
}